<div class="filters">
  <div *ngIf="!isEditing" class="wrap-container flex-row flex-start-center flex-gap-16">
    <div class="wrap-container value-display flex-100 flex-row flex-start-center flex-gap-16">
      <div class="flex-nogrow filter-icon filter-icon-center filter-position">
        <ukg-button icon-only parent-icon="filter" [disabled]="!filters" (click)="startEditing()" data-automation="toggle_filter_edit_btn">
        </ukg-button>
      </div>
      <div class="flex-column">
        <ukg-label type="tertiary" [class.label-display]="false" data-automation="pay_date_label" translate>AT_A_GLANCE.PAY_DATE_LABEL</ukg-label>
        <ukg-label type="primary" [class.value-display]="false" data-automation="pay_date_value">
          <span *ngIf="filters">{{filters.payDate | ultishortdate:'l'}}</span>
        </ukg-label>
      </div>
      <div class="flex-column">
        <ukg-label type="tertiary" [class.label-display]="false" data-automation="payroll_type_label" translate>AT_A_GLANCE.PAYROLL_TYPE_LABEL</ukg-label>
        <ukg-label type="primary" [class.value-display]="false" data-automation="payroll_type_value">
          <span *ngIf="filters">{{getPayrollTypeName()}}</span>
        </ukg-label>
      </div>
      <div class="flex-column">
        <ukg-label type="tertiary" [class.label-display]="false" data-automation="pay_group_label" translate>AT_A_GLANCE.PAY_GROUP_LABEL</ukg-label>
        <ukg-popover #payGroupTooltip content-type="custom">
          <ukg-label type="primary" *ngIf="filters">{{selectedPayGroups | translateList:getCode}}</ukg-label>
        </ukg-popover>
        <ukg-label type="primary" *ngIf="filters" [class.value-display]="false" data-automation="pay_group_value" placement="bottom"
          (mouseenter)="payGroupTooltip.present($event.target)"
          (mouseleave)="payGroupTooltip.dismiss()">
          <span *ngIf="selectedPayGroups.length === allPayGroups.length" translate [translateParams]="{ count: filters.payGroups.length || allPayGroups.length }">AT_A_GLANCE.SELECTED_PAYGROUPS_ALL</span>
          <span *ngIf="filters.payGroups.length > 1 && filters.payGroups.length < allPayGroups.length && filters.payGroups.length < 100"
            translate [translateParams]="{ count: filters.payGroups.length, total: allPayGroups.length }">AT_A_GLANCE.SELECTED_PAYGROUPS_FEW</span>
          <span *ngIf="filters.payGroups.length > 1 && filters.payGroups.length < allPayGroups.length && filters.payGroups.length >= 100"
            translate [translateParams]="{ count: filters.payGroups.length, total: allPayGroups.length }">AT_A_GLANCE.SELECTED_PAYGROUPS_MANY</span>
          <span *ngIf="filters.payGroups.length === 1" translate [translateParams]="{ name: filters.payGroups[0].code.trim() }">AT_A_GLANCE.SELECTED_PAYGROUPS_SINGLE</span>
        </ukg-label>
        <ukg-popover #payGroupTooltip position="bottom">{{selectedPayGroups.length > 1 && selectedPayGroups.length < 10 ? payGroupTooltip : null}}</ukg-popover>
      </div>
  </div>
</div>
  <div *ngIf="isEditing">
    <div class="flex-column">
      <div class="inline-edit-filter-row flex-row">
        <ukg-button icon-only parent-icon="filter" class="filter-icon">
        </ukg-button>
        <div class="flex hidden-accessible-filter" translate>AT_A_GLANCE.FILTERS_LABEL</div>
        <ukg-button icon-only parent-icon="close" (click)="cancelEdits()" data-automation="toggle_filter_edit_btn">
        </ukg-button>
      </div>
      <div [class.inline-edit-container]="true">
        <div class="wrap-container flex-column">
          <div class="pay-container-spacing">
            <ukg-label type="tertiary" data-automation="pay_date_edit_label" translate>AT_A_GLANCE.PAY_DATE_EDIT_LABEL</ukg-label>
          <div *ngIf="editFilters.payDate !== defaultDate">
            <ssg-date-picker [(ngModel)]="editFilters.payDate" [minDate]="minDate" [config]="payrollScheduleDates" (invalidDateChanged)="isInvalid = $event"></ssg-date-picker>
          </div>
        </div>
        <div class="wrap-container pay-container-spacing flex-column">
          <ukg-input-container [block]="true" [size]="medium">
            <ukg-label data-automation="payroll_type_edit_label" translate>AT_A_GLANCE.PAYROLL_TYPE_LABEL</ukg-label>
            <ukg-select data-automation="payroll_type_edit_dropdown" [(ngModel)]="editFilters.payrollType" [disabled]="!allPayrollTypes.length"
              bindLabel="localizedName" bindValue="value" (ukgChange)="UpdateFilter($event)" [compareWith]="payrollTypeCompareWith">
                <ukg-select-option *ngFor="let option of allPayrollTypes" [value]="option.value" [label]="option.localizedName"></ukg-select-option>
            </ukg-select>
          </ukg-input-container>
          </div>
          <div class="wrap-container pay-group-spacing flex-column">
            <div class="flex-100">
                  <ukg-input-container [block]="true" [size]="medium">
                    <ukg-label data-automation="pay_group_edit_label" translate>AT_A_GLANCE.PAY_GROUP_LABEL</ukg-label>
                      <ukg-select data-automation="pay_group_edit_dropdown" searchPlaceholder="{{'AT_A_GLANCE.SEARCH' | translate}}" placeholder="{{ 'AT_A_GLANCE.PAY_GROUP_PLACEHOLDER' | translate}}" [disabled]="!allPayGroups.length"
                       [multiple]="true" [(ngModel)]="editFilters.payGroups"  bindLabel="code">
                        <ukg-select-option *ngFor="let item of allPayGroups" [value]="item" [label]="item.code" [selected]="filterSelection(item)" ></ukg-select-option>
                      </ukg-select>
                    </ukg-input-container>
              </div>
          </div>
      <div class="inline-buttons-container flex-row flex-gap-10">
        <ukg-button-group>
          <ukg-button size="medium" emphasis="mid" (click)="clearEditFilters()" data-automation="clear_filter_edit_btn" translate>COMMON.BUTTON_RESET</ukg-button>
          <ukg-button size="medium" emphasis="high" (click)="applyEdits()" data-automation="apply_filter_edit_btn" [disabled]="isInvalid" translate>COMMON.BUTTON_APPLY</ukg-button>
        </ukg-button-group>
      </div>
    </div>
  </div>
</div>
</div>

